
  import { defineComponent } from 'vue';
  import LinkButton from '@/ui/components/checklist/LinkButton.vue';
  import ChooseMethodAction from '@/ui/components/checklist/choose-method/ChooseMethodAction.vue';
  import { router, useCurrentRoute } from '@/ui/routes';
  import { useChecklistSessionStorage } from '@/ui/concerns/useChecklistSessionStorage';
  import { t } from '@/ui/i18n/i18n';

  export default defineComponent({
    components: {
      LinkButton,
      ChooseMethodAction,
    },
    setup() {
      const currentRoute = useCurrentRoute();
      const prevRoute = currentRoute.value.query.fromRoute;
      const { saveExitRoute, exitAction } = useChecklistSessionStorage();

      const title = currentRoute.value.query.first === 'true'
        ? t('checklist.create-checklist-page.title-first')
        : t('checklist.create-checklist-page.title');

      if (prevRoute) {
        saveExitRoute(prevRoute as string);
      }

      const onGoBack = () => {
        exitAction();
      };

      const goToCreateFromScratch = () => {
        router.push({ name: 'checklistCreate' });
      };

      const goToFileUpload = () => {
        router.push({ name: 'checklistFileUpload' });
      };

      const goToPrompt = () => {
        router.push({ name: 'checklistAiPrompt' });
      };

      const goToTemplateLibrary = () => {
        router.push({ name: 'checklistChooseTemplate' });
      };

      return {
        title,
        onGoBack,
        goToCreateFromScratch,
        goToFileUpload,
        goToPrompt,
        goToTemplateLibrary,
      };
    },
  });
